<template>
  <form id="shop" class="" @submit.prevent="submitForm">
    <div class="bg-white mb-2">
      <div class="form-shadow">
        <div class="row">
          <div class="col-lg-12" id="sells-s">
            <div class="form-group">
              <label>Phone Number</label>
              <Field
                name="phone"
                as="input"
                class="form-control rounded-0 sel-control"
                v-model="formData.phone"
                placeholder="Enter Your Phone Number"
              ></Field>
              <ErrorMessage name="phone" class="error" />
            </div>
          </div>
          <div class="col-12-6" id="sells-s">
            <div class="form-group">
              <label>Enter PIN</label>
              <div class="row justify-content-center">
                <div class="col-lg-12" id="sells-s">
                  <div class="otp-number">
                    <div class="form-group">
                      <input
                        type="tel"
                        class="form-control rounded-0 otp-control"
                        placeholder=""
                        maxlength="1"
                        name="numericInput1"
                        v-model="pinInput1"
                        @input="moveToNext(1)"
                        @keydown="handleBackspace(1, $event)"
                      >
                      <span class="text-danger"></span>
                    </div>
                    <div class="form-group">
                      <input
                        type="tel"
                        class="form-control rounded-0 otp-control"
                        placeholder=""
                        maxlength="1"
                        name="numericInput2"
                        v-model="pinInput2"
                        @input="moveToNext(2)"
                        @keydown="handleBackspace(2, $event)"
                      >
                      <span class="text-danger"></span>
                    </div>
                    <div class="form-group">
                      <input
                        type="tel"
                        class="form-control rounded-0 otp-control"
                        placeholder=""
                        maxlength="1"
                        name="numericInput3"
                        v-model="pinInput3"
                        @input="moveToNext(3)"
                        @keydown="handleBackspace(3, $event)"
                      >
                      <span class="text-danger"></span>
                    </div>
                    <div class="form-group">
                      <input
                        type="tel"
                        class="form-control rounded-0 otp-control"
                        placeholder=""
                        maxlength="1"
                        name="numericInput4"
                        v-model="pinInput4"
                        @keydown="handleBackspace(4, $event)"
                      >
                      <span class="text-danger"></span>
                    </div>
                    <ErrorMessage name="password" class="error" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6"></div>
            <div class="col-6 text-end">
              <a href="auth/forget_password">
                <p class="forget-text">Forgot Password?</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <input type="submit" class="btn btn-primary fw-600 rounded-0 reg-btn" value="LOGIN">
    </div>
    <div class="already-text">
      <p>Don't have an account?</p><a href="register"><span>Sign up</span></a>
    </div>
  </form>
</template>

<script setup>
import { ref } from 'vue';
import * as yup from 'yup';
import { useForm, Field, ErrorMessage } from 'vee-validate';
import { login, dasboard } from '../constant/auth.js';

const validationSchema = yup.object({
  phone: yup.string().required('Phone Number is required').matches(/^[0-9]{10}$/, 'Phone number must be a valid 10 digits'),
});

const { handleSubmit: veeHandleSubmit, errors } = useForm({
  validationSchema,
  initialValues: {
    phone: '',
    remember: false,
  },
})

const formData = ref({
  phone: '',
  password: '',
  remember: false,
});

const pinInput1 = ref('');
const pinInput2 = ref('');
const pinInput3 = ref('');
const pinInput4 = ref('');

function moveToNext(inputNumber) {
  switch (inputNumber) {
    case 1:
      if (pinInput1.value.length >= 1) {
        document.getElementsByName('numericInput2')[0].focus();
      }
      break;
    case 2:
      if (pinInput2.value.length >= 1) {
        document.getElementsByName('numericInput3')[0].focus();
      }
      break;
    case 3:
      if (pinInput3.value.length >= 1) {
        document.getElementsByName('numericInput4')[0].focus();
      }
      break;
    default:
      break;
  }
}

function handleBackspace(inputNumber, event) {
  if (event.key === 'Backspace') {
    switch (inputNumber) {
      case 2:
        if (pinInput2.value.length === 0) {
          document.getElementsByName('numericInput1')[0].focus();
        }
        break;
      case 3:
        if (pinInput3.value.length === 0) {
          document.getElementsByName('numericInput2')[0].focus();
        }
        break;
      case 4:
        if (pinInput4.value.length === 0) {
          document.getElementsByName('numericInput3')[0].focus();
        }
        break;
      default:
        break;
    }
  }
}

const submitForm = veeHandleSubmit(async () => {
  console.log('Form submitted:', formData.value);
  const pin = pinInput1.value + pinInput2.value + pinInput3.value + pinInput4.value;
  try {
    const loginRoute = login();
    const { path, method } = loginRoute;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const response = await fetch(path, {
      method,
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-TOKEN': csrfToken
      },
      body: JSON.stringify({
        mobile: formData.value.phone,
        password: pin
      })
    });
    if (response.ok) {
      const responseData = await response.json();
      console.log("Login Successfull", responseData);
      window.successSnackbar(responseData.message);
      const dashboardRoute = dasboard();
      window.location.href = responseData.appUrl;
    } else {
      const responseData = await response.json();
      console.error('Login failed:', responseData);
      window.errorSnackbar(responseData.message);
    }
  } catch (error) {
    console.log(error);
  }
});
</script>

<style scoped>
.error {
  color: red;
}
</style>
